import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F4F4F0]">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#555]">
          Authenticating
        </p>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F4F4F0]">
        <div className="border-2 border-[#0A0A0A] bg-white p-12 max-w-lg">
          <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#D91919]">
            403 — Insufficient Role
          </p>
          <h2 className="text-3xl font-bold tracking-tight mt-2 text-[#0A0A0A]">
            You can&apos;t open this module.
          </h2>
          <p className="text-sm text-[#555] mt-4 font-mono">
            Your role <b>{user.role}</b> is not authorised for this view. Ask an admin
            to grant access.
          </p>
        </div>
      </div>
    );
  }
  return children;
}
